<template>
  <component id="athlete-positions" :is="field" :positions="positions" />
</template>

<script>
import BaseballSoftball from './AthletePositionGraphics/BaseballSoftball.vue'
import Basketball from './AthletePositionGraphics/Basketball.vue'
import Fieldhockey from './AthletePositionGraphics/Fieldhockey.vue'
import Lacrossefemale from './AthletePositionGraphics/Lacrossefemale.vue'
import Lacrossemale from './AthletePositionGraphics/Lacrossemale.vue'
import Soccer from './AthletePositionGraphics/Soccer.vue'
import Volleyball from './AthletePositionGraphics/Volleyball.vue'

const components = {
    BaseballSoftball,
    Basketball,
    Fieldhockey,
    Lacrossefemale,
    Lacrossemale,
    Soccer,
    Volleyball,
}

export default {
    props: {
        sport: {
            type: Object,
            default: null
        },
        positions: {
            type: Array,
            default: null
        },
        gender: {
            type: String,
            default: null
        }
    },
    methods: {
    },
    computed: {
        field() {
            // Only import the field/court for the sport that's associated with the profile.

            // Transform the sport prop to capitalize the first letter, and remove any spaces.
            let sportComponentName = (this.sport.name[0].toUpperCase() + this.sport.name.substr(1)).replace(' ', '');
            
            // Use Same field for Baseball & Softball
            if ( /^(Base|Soft)ball/.test(sportComponentName) ) sportComponentName = "BaseballSoftball";
            
            // If the sport is Lacrosse, load the correct component based on gender.
            if (sportComponentName === "Lacrosse" && this.gender) sportComponentName += this.gender;
            
            // Dynamically load the component
            /* webpackChunkName: "svg-field" */
            return components[sportComponentName]
        }
    }
}
</script>

<style scoped>
    /* Move the styles for all the SVGs in the parent container element, so we don't have duplicate CSS */
	>>> .field-bg {fill:none;}
	>>> .field-bg {fill:#E4E5EA;}
	>>> .field-lines {fill:#FFFFFF;}
	>>> .position {fill:#AEB0BC;}
	>>> .active {fill:#2DD287;}
	>>> .active .position {fill:#2DD287;}
</style>